import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[app-autocomplete-state]',
})
export class AutocompleteStateDirective {
  // Input
  @Input({ alias: 'app-autocomplete-state', required: true }) type!: 'default' | 'no-results';

  // HostBinding
  @HostBinding('class') class = `block border-t border-gray-100 px-6 py-14 text-center text-sm sm:px-14
    [&>app-icon]:inline-block [&>app-icon]:mx-auto [&>app-icon]:text-gray-400`;
}
